import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Forget = () => import('@/views/pages/Forget')
const Change = () => import('@/views/pages/Change')

// Views - ABM
const Countries = () => import('@/views/ABM/Countries')
const GroupStandards = () => import('@/views/ABM/GroupStandards')
const FileTypes = () => import('@/views/ABM/FileTypes')
const Protocols = () => import('@/views/ABM/Protocols')
const Files = () => import('@/views/ABM/Files')
const Clients = () => import('@/views/ABM/Clients')
const ClientsGlobalGap = () => import('@/views/ABM/ClientsGlobalGap')
const ProtocolsGlobalGap = () => import('@/views/ABM/ProtocolsGlobalGap')
const Collaborators = () => import('@/views/ABM/Collaborators')

const RmsValidationService = () => import('@/views/ABM/RmsValidationService')
const SiteValidationService = () => import('@/views/ABM/SiteValidationService')
const ProducerValidationService = () => import('@/views/ABM/ProducerValidationService')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      meta: { auth: true },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { auth: true }
        },
        {
          path: 'Countries',
          name: 'Countries',
          component: Countries,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'GroupStandards',
          name: 'GroupStandards',
          component: GroupStandards,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'Files',
          name: 'Files',
          component: Files,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'FileTypes',
          name: 'FileTypes',
          component: FileTypes,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'Protocols',
          name: 'Protocols',
          component: Protocols,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'Clients',
          name: 'Clients',
          component: Clients,
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'ClientsGlobalGap',
          name: 'ClientsGlobalGap',
          component: ClientsGlobalGap,
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'ProtocolsGlobalGap',
          name: 'ProtocolsGlobalGap',
          component: ProtocolsGlobalGap,
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'RmsValidationService',
          name: 'RmsValidationService',
          component: RmsValidationService,
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'SiteValidationService',
          name: 'SiteValidationService',
          component: SiteValidationService,
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'ProducerValidationService',
          name: 'ProducerValidationService',
          component: ProducerValidationService,
          meta: { auth: ['A', 'S', 'U'] }
        },                        
        {
          path: 'Collaborators',
          name: 'Collaborators',
          component: Collaborators,
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'Users',
          name: 'Users',
          component: () => import('@/views/security/Users'),
          meta: { auth: ['S'] }
        },
        {
          path: 'Roles',
          name: 'Roles',
          component: () => import('@/views/security/Roles'),
          meta: { auth: ['S'] }
        },
        {
          path: 'AuditorProtocol',
          name: 'AuditorProtocol',
          component: () => import('@/views/security/AuditorProtocol'),
          meta: { auth: ['S'] }
        },
        {
          path: 'Comments',
          name: 'Comments',
          component: () => import('@/views/ABM/Comments'),
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'OfferAttachments',
          name: 'OfferAttachments',
          component: () => import('@/views/ABM/OfferAttachments'),
          meta: { auth: ['A', 'S'] }
        },
        {
          path: 'detallecomercial',
          name: '01_DetalleComercial',
          component: () => import('@/views/visuales/comercial/01_DetalleComercial'),
          meta: { auth: ['COM01'] }
        },
        {
          path: 'grillacomercial',
          name: '01_GrillaComercial',
          component: () => import('@/views/visuales/comercial/01_GrillaComercial'),
          meta: { auth: ['COM01'] }
        },
        {
          path: 'comercial/NuevaOferta',
          name: '01_ComercialNuevaOferta',
          component: () => import('@/views/visuales/comercial/01_NuevaOferta'),
          meta: { auth: ['COM01'] }
        },
        {
          path: 'grillaplanificacion',
          name: '02_GrillaPlanificacion',
          component: () => import('@/views/visuales/planificacion/02_GrillaPlanificacion'),
          meta: { auth: ['PLA01'] }
        },
        {
          path: 'detalleplanificacion',
          name: '02_DetallePlanificacion',
          component: () => import('@/views/visuales/planificacion/02_DetallePlanificacion'),
          meta: { auth: ['PLA01'] }
        },
        {
          path: 'grillainspeccion',
          name: '03_GrillaInspeccion',
          component: () => import('@/views/visuales/inspeccion/03_GrillaInspeccion'),
          meta: { auth: ['INS01'] }
        },
        {
          path: 'detalleinspeccion',
          name: '03_DetalleInspeccion',
          component: () => import('@/views/visuales/inspeccion/03_DetalleInspeccion'),
          meta: { auth: ['INS01'] }
        },
        {
          path: 'grillabackoffice',
          name: '04_GrillaBackoffice',
          component: () => import('@/views/visuales/backoffice/04_GrillaBackoffice'),
          meta: { auth: ['BOF01'] }
        },
        {
          path: 'detallebackoffice',
          name: '04_DetalleBackOffice',
          component: () => import('@/views/visuales/backoffice/04_DetalleBackoffice'),
          meta: { auth: ['BOF01'] }
        },
        {
          path: 'grillaoperaciones',
          name: '05_GrillaOperaciones',
          component: () => import('@/views/visuales/operaciones/05_GrillaOperaciones'),
          meta: { auth: ['OPE01'] }
        },
        {
          path: 'detalleoperaciones',
          name: '05_DetalleOperaciones',
          component: () => import('@/views/visuales/operaciones/05_DetalleOperaciones'),
          meta: { auth: ['OPE01'] }
        },
        {
          path: 'grillagestores',
          name: '06_GrillaGestores',
          component: () => import('@/views/visuales/gestores/06_GrillaGestores'),
          meta: { auth: ['GES01'] }
        },
        {
          path: 'detallegestores',
          name: '06_DetalleGestores',
          component: () => import('@/views/visuales/gestores/06_DetalleGestores'),
          meta: { auth: ['GES01'] }
        },
        {
          path: 'grillareportes',
          name: '07_GrillaReportes',
          component: () => import('@/views/visuales/reportes/07_GrillaReportes'),
          meta: { auth: ['REP01'] }
        },
        {
          path: 'detalleadministracion',
          name: '08_DetalleAdministracion',
          component: () => import('@/views/visuales/administracion/08_DetalleAdministracion'),
          meta: { auth: ['ADM01'] }
        },
        {
          path: 'grillaadministracion',
          name: '08_GrillaAdministracion',
          component: () => import('@/views/visuales/administracion/08_GrillaAdministracion'),
          meta: { auth: ['ADM01'] }
        },
        {
          path: 'globalgap/newaudit',
          name: 'NewAudit',
          component: () => import('@/views/globalgap/NewAudit'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'globalgap/templates',
          name: 'Templates',
          component: () => import('@/views/globalgap/Templates'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'clientsGlobalGap',
          name: 'clientsGlobalGap',
          component: () => import('@/views/ABM/ClientsGlobalGap'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'protocolsGlobalGap',
          name: 'protocolsGlobalGap',
          component: () => import('@/views/ABM/ProtocolsGlobalGap'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'rmsValidationService',
          name: 'rmsValidationService',
          component: () => import('@/views/ABM/RmsValidationService'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'siteValidationService',
          name: 'siteValidationService',
          component: () => import('@/views/ABM/SiteValidationService'),
          meta: { auth: ['A', 'S', 'U'] }
        },
        {
          path: 'producerValidationService',
          name: 'producerValidationService',
          component: () => import('@/views/ABM/ProducerValidationService'),
          meta: { auth: ['A', 'S', 'U'] }
        }                      
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: { auth: false }
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
          meta: { auth: false }
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: { auth: false }
        },
        {
          path: 'Forget',
          name: 'Forget',
          component: Forget,
          meta: { auth: false }
        },
        {
          path: 'Change',
          name: 'Change',
          component: Change,
          meta: { auth: true }
        }
      ]
    }
  ]
})
